class storage {
  get(key) {
    const value = localStorage.getItem(key);
    // 判断获取的元素是否为JSON
    try {
      return JSON.parse(value);
    } catch (err) {
      return value;
    }
  }
  set(key, value) {
    // 判断value是否为对象，将其转换成JSON格式
    if (typeof value === "object") {
      value = JSON.stringify(value);
    }
    localStorage.setItem(key, value);
  }
  remove(key) {
    localStorage.removeItem(key);
  }
  clear() {
    localStorage.clear();
  }
}
export default new storage();
